module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"helpCenter":"Help Center","dashboard":"Dashboard"},"zh":{"helpCenter":"帮助中心","dashboard":"仪表盘"},"kr":{"helpCenter":"지원 센터","dashboard":"계기반"}}')
  delete Component.options._Ctor
}
